import * as React from 'react';
export const IcCovid19 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 10a1 1 0 00-1 1h-1.08a7 7 0 00-1.32-3.19l.76-.76a1 1 0 101.42-1.41l-1.42-1.42a1 1 0 10-1.41 1.42l-.76.76A7 7 0 0013 5.08V4a1 1 0 100-2h-2a1 1 0 100 2v1.08A7 7 0 007.81 6.4l-.76-.76a1 1 0 10-1.41-1.42L4.22 5.64a1 1 0 101.42 1.41l.76.76A7 7 0 005.08 11H4a1 1 0 10-2 0v2a1 1 0 102 0h1.08a7 7 0 001.32 3.19l-.76.81a1 1 0 10-1.42 1.41l1.42 1.42a1 1 0 101.41-1.42l.76-.76A7 7 0 0011 18.92V20a1 1 0 000 2h2a1 1 0 000-2v-1.08a7 7 0 003.19-1.32l.76.76a1.002 1.002 0 00.705 1.71 1 1 0 00.705-.29l1.42-1.42a1 1 0 10-1.42-1.41l-.76-.76A7 7 0 0018.92 13H20a1 1 0 002 0v-2a1 1 0 00-1-1zm-11 2a2 2 0 110-4 2 2 0 010 4zm2 5a1 1 0 110-2 1 1 0 010 2zm4-5a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
